import './gallery.styles.scss';

import GalleryController from './gallery.controller';

export default angular.module('directives.abGallery', [])
  .directive('abGallery', () => {
    'ngInject';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        images: '=',
        panoramic: '=?',
      },
      controller: GalleryController,
      templateUrl: require('./gallery.template.html'),
      link: (scope) => {
        scope.$watch('images', (newValue) => {
          if (newValue === undefined) return;
          scope.updateGallery();
        });
      },
    };
  })
  .name;
